import clsx from 'clsx'

const DEFAULT_OPTIONS = {
  hideQuickAdd: false,
  hideQuickAddModal: true,
  hideSwatches: false,
  hidePromolines: false,
  hideBadges: false,
  hideWishlist: false
}

const SkeletonImage = () => {
  return (
    <div className="relative w-full aspect-2/3 bg-type-white-secondary overflow-hidden animate-pulse">
    </div>
  )
}

export const SkeletonCard = ({ className, options = DEFAULT_OPTIONS }) => {
  const {
    hideQuickAddModal = DEFAULT_OPTIONS.hideQuickAddModal,
    hideSwatches = DEFAULT_OPTIONS.hideSwatches,
    hidePromolines = DEFAULT_OPTIONS.hidePromolines
  } = options

  const showStarRatingRow = hidePromolines
  const showSecondRow = !hideSwatches || !hidePromolines || showStarRatingRow

  return (
    <div className={clsx('grow flex flex-col w-full bg-secondary outline-card animate-pulse', className)}>
      <SkeletonImage />
      <div
        className={clsx(
          'grow flex flex-col gap-y-0.5 lg:gap-y-0.875 p-1 lg:p-1.5 animate-pulse',
          !hideQuickAddModal && 'pb-0.5'
        )}
      >
        <div className="flex lg-max:flex-col lg:justify-between gap-x-0.75 gap-y-0.125">
          <div className="w-1/2 h-0.75 bg-type-white-secondary"></div>
          <div className="w-1/4 h-0.75 bg-type-white-secondary"></div>
        </div>

        {showSecondRow && (
          <div className="flex lg-max:flex-col gap-y-0.5">
            {!hideSwatches && <div className="w-1/2 h-0.875 bg-type-white-secondary"></div>}
            {!hidePromolines && <div className="w-1/2 h-0.875 bg-type-white-secondary"></div>}
            {showStarRatingRow && hidePromolines && (
              <div className="w-1/2 h-0.875 bg-type-white-secondary"></div>
            )}
          </div>
        )}

        {(!hideQuickAddModal) && (
          <div className="grow flex lg:hidden items-end">
            <div className="w-[76px] h-[44px] bg-type-white-secondary"></div>
          </div>
        )}
      </div>
    </div>
  )
}
